import "../index/product.scss";
import "../index/innovation.scss";
import "../index/advances.scss";
import "../order/form.scss";
import "../index/top.scss";
import "./index.scss";
import "./product.scss";
import "./reviews.scss";
import "./swiper.scss";
import "./write-review-modal.scss";
